import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import FormSidebar from '../FormSidebar';
import GradientText from 'components/GradientText';
import { useSelector } from 'react-redux';
import { selectHomepage } from 'store/slices/HomepageSlice';

const DefaultFormSidebar = () => {
    const { cta_tag, cta_title, cta_image } = useSelector(selectHomepage);

    return (
        <FormSidebar>
            <LabelButton>{cta_tag}</LabelButton>
            <div className="pb-24">
                <GradientText size="middle" textColor="white">
                    <span dangerouslySetInnerHTML={{ __html: cta_title }} />
                </GradientText>
            </div>
            <img src={cta_image} alt="" />
        </FormSidebar>
    );
};

export default DefaultFormSidebar;
